import { render, staticRenderFns } from "./AllDocumentModal.vue?vue&type=template&id=63b536f5&scoped=true"
import script from "./AllDocumentModal.vue?vue&type=script&lang=js"
export * from "./AllDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./AllDocumentModal.vue?vue&type=style&index=0&id=63b536f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b536f5",
  null
  
)

export default component.exports